<template>
  <div>
    <mdb-btn @click="$emit('finished')" icon="arrow-left">Back to Console</mdb-btn>
    <mdb-btn @click="loadDetails" icon="recycle">Refresh</mdb-btn>
    <div v-if="details">
      <mdb-card class="mb-4">
        <mdb-card-header class="secondary-color">
          <h4>Unconfirmed Users</h4>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tbl striped responsive>
            <mdb-tbl-head>
              <tr>
                <th>ID</th>
                <th>Email</th>
                <th>Created</th>
                <th>&nbsp;</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr v-for="u in details.unconfirmed" :key="u.id">
                <td>{{ u.id }}</td>
                <td>{{ u.email }}</td>
                <td>{{ u.created }}</td>
                <td>
                  <mdb-btn @click="confirmUser(u)" icon="check" size="sm" rounded>Confirm</mdb-btn>
                  <mdb-btn @click="deleteUser(u)" icon="trash" color="danger" size="sm" rounded>Delete</mdb-btn>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>
    </div>
    <yes-no-modal v-if="deleteModal" @yes="doDelete" @no="deleteModal=false"/>

  </div>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import YesNoModal from "../common/YesNoModal";
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

export default {
  name: "admin-aws-cognito",
  display: "Cognito",
  order: 1,
  components: {
    mdbContainer,
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbIcon,
    mdbCardBody,
    mdbCardFooter,
    mdbTbl,
    mdbTblBody,
    mdbTblHead,
    YesNoModal
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    }
  },
  async mounted() {
    this.loadDetails()
  },
  data() {
    return {
      details: null,
      deleteCandidate: null,
      deleteModal: false
    }
  },
  methods: {
    deleteUser(user) {
      this.deleteCandidate = user;
      this.deleteModal = true;
    },
    doDelete() {
      this.deleteModal = false
      this.$store.dispatch("setExecuting", true)
      api.post("/aws/cognitoDelete", {sub: this.deleteCandidate.id}).then(
        (results) => {
          let loc = this.details.unconfirmed.indexOf(this.deleteCandidate)
          if (loc>-1) this.details.unconfirmed.splice(loc,1)
          this.$notify.success({message: "Deleted!", timeOut: 3000})
          this.deleteCandidate = null
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    confirmUser(user) {
      this.$store.dispatch("setExecuting", true)
      api.post("/aws/cognitoConfirm", {sub: user.id}).then(
        (results) => {
          let loc = this.details.unconfirmed.indexOf(user)
          if (loc>-1) this.details.unconfirmed.splice(loc,1)
          this.$notify.success({message: "Confirmed!", timeOut: 3000})
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    loadDetails() {
      this.$store.dispatch("setExecuting", true)
      api.get("/aws/cognitoDetails/").then(
        (results) => {
          this.details = results.data
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
;
</script>
